<div class="loading-spinner" *ngIf="isPending$ | async">
    <div class="background"></div>
    <mat-spinner [diameter]="70"></mat-spinner>
</div>

<app-list-quotes *ngIf="(selectedQuote$ | async) == null && (quoteListOpen$ | async)"
                 (deleteQuote)="onDeleteQuote($event)"
                 (selectQuote)="onSelectQuote($event)"
                 (closeQuoteList)="onCloseQuoteList()"
                 [quotes]="quotes$ | async"
                 [isPending]="isPending$ | async">
</app-list-quotes>

<app-list-quotes *ngIf="(selectedQuote$ | async) == null && (submittedQuoteListOpen$ | async)"
                 (deleteQuote)="onDeleteQuote($event)"
                 (selectQuote)="onSelectQuote($event)"
                 (closeQuoteList)="onCloseQuoteList()"
                 [quotes]="submittedQuotes$ | async"
                 [isPending]="isPending$ | async">
</app-list-quotes>

<create-new-quote-from-root *ngIf="(selectedQuote$ | async) == null && (createNewQuoteOpen$ | async)">
</create-new-quote-from-root>

<app-quote-view-selection *ngIf="(
(quoteViewSelectionOpen$ | async) && (selectedQuote$ | async) == null  && (newlyCreatedQuote$ | async) == null||
(!(quoteListOpen$ | async) && (selectedQuote$ | async) != null) ||
(!(createNewQuoteOpen$ | async) && (selectedQuote$ | async) != null)
) &&

(quoteViewSelectionOpen$ | async) &&
!(quoteListOpen$ | async) &&
!(submittedQuoteListOpen$ | async) && !(createNewQuoteOpen$ | async)"


                          (close)="onCloseQuoteViewSelection()"
                          (openQuotesList)="onOpenQuoteList()"
                          (openCreateQuote)="onOpenCreateQuote()"
                          (openSubmittedQuotesList)="onOpenSubmittedQuotesList()">
</app-quote-view-selection>

<app-quote-detail *ngIf="(selectedQuote$ | async) != null"
                  [selectedQuote]="selectedQuote$ | async"
                  [quoteBarItem]="selectedQuoteBarItem$ | async"
                  [productDictionary]="productDictionary$ | async"
                  [productsIsLoading]="productsIsLoading$ | async"
                  [countryDictionary]="countryDictionary$ | async"
                  (deselectQuote)="onDeselectQuote()"
                  (deleteQuote)="onDeleteQuote($event)"
                  (deleteQuoteProduct)="onDeleteQuoteProduct($event)"
                  (editQuoteProduct)="onEditQuoteProduct($event)"
                  (closeQuoteList)="onCloseQuoteList()">
</app-quote-detail>


<create-new-quote-from-root-landing *ngIf="(newlyCreatedQuote$ | async) != null"
                                    [quoteBarItem]="newlyCreatedQuoteBarItem$ | async"
                                    (deselectQuote)="onDeselectQuote()"
                                    (deleteQuote)="onDeleteQuote($event)"
                                    (close)="onCloseQuoteViewSelection()">
</create-new-quote-from-root-landing>
